export default __webpack_public_path__ + "static/media/work.7fe861bc.jpg";